import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from 'components/Icon';
import InfographicsCard from 'components/InfographicsCard';
import WebcamBlock from 'components/WebcamBlock';

import css from './RightNowBox.module.scss';

class RightNowBox extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        header: PropTypes.string.isRequired,
        webcams: PropTypes.array,
        infographics: PropTypes.array,
    }

    state = {
        infographic: 0,
        webcam: 0,
    }

    _nextWebcam = () => this.setState(state => ({
        webcam: state.webcam + 1 >= this.props.webcams.length ? 0 : state.webcam + 1
    }))

    _prevWebcam = () => this.setState(state => ({
        webcam: state.webcam == 0 ? this.props.webcams.length - 1 : state.webcam - 1
    }))

    _nextInfographic = () => this.setState(state => ({
        infographic: state.infographic + 1 >= this.props.infographics.length ? 0 : state.infographic + 1
    }))

    _prevInfographic = () => this.setState(state => ({
        infographic: state.infographic == 0 ? this.props.infographics.length - 1 : state.infographic - 1
    }))

    render() {
        const {
            className,
            header,
            webcams,
            infographics,
        } = this.props;

        const {
            infographic,
            webcam,
        } = this.state;

        return (
            <div className={cn(css.box, className)}>
                {header && <h2 className={css.header}>{header}</h2>}
                {webcams && webcams.length > 0 && (
                    <div className={css.webcams}>
                        <ul>
                            {webcams.map((w, i) => (
                                <li key={i} style={{ display: i !== webcam ? 'none' : null }}>
                                    <WebcamBlock {...w} />
                                </li>
                            ))}
                        </ul>
                        {webcams.length > 1 && (
                            <nav>
                                <ul>
                                    <li>
                                        <button onClick={this._prevWebcam}>
                                            <Icon icon="arrow-grey-light-left" />
                                        </button>
                                    </li>
                                    <li className={css.indicators}>
                                        {webcams.map((w,i) => (
                                            <div
                                                className={i === webcam ? css.active : null}
                                                key={i}
                                            >{`Webcam ${i+1}`}</div>
                                        ))}
                                    </li>
                                    <li>
                                        <button onClick={this._nextWebcam}>
                                            <Icon icon="arrow-grey-light-right" />
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>
                )}
                {infographics && infographics.length > 0 && (
                    <div className={css.infographics}>
                        <ul>
                            {infographics.map((info, i) => (
                                <li key={i} style={{ display: i !== infographic ? 'none' : null }}>
                                    <InfographicsCard
                                        {...info}
                                    />
                                </li>
                            ))}
                        </ul>
                        {infographics.length > 1 && (
                            <nav>
                                <ul>
                                    <li>
                                        <button onClick={this._prevInfographic}>
                                            <Icon icon="arrow-grey-light-left" />
                                        </button>
                                    </li>
                                    <li className={css.indicators}>
                                        {infographics.map((_, i) => (
                                            <div
                                                className={i === infographic ? css.active : null}
                                                key={i}
                                            >{`Infographic ${i + 1}`}</div>
                                        ))}
                                    </li>
                                    <li>
                                        <button onClick={this._nextInfographic}>
                                            <Icon icon="arrow-grey-light-right" />
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>
                )}

            </div>
        );
    }
}

export default RightNowBox;



// WEBPACK FOOTER //
// ./src/components/RightNowBox/RightNowBox.jsx